import type { FaireProductEntity } from "../../entity_types/product";

export const p_yswfr8nque: FaireProductEntity = {
  token: "p_yswfr8nque",
  type: "product",
  name: "Organic Cotton Baby Mittens 3 Pack - Ranunculus",
  brandToken: "b_np5ktd5ja2",
  brandName: "Burt's Bees Baby",
  imageUrl: "https://cdn.faire.com/fastly/2305030cf5e1df686b566bbb45c2f516e2c7d85e79ec12c46e2c9c16e4c6daf1.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.5,
  description: "Double duty 100% organic cotton mittens keep your little one's hands toasty warm, while protecting delicate skin from those tiny (but mighty!) newborn nails.\n\n * Gentle encased elastic wrists \n * Perfect fit to prevent scratching from your baby's tiny nails \n * 100% organic, breathable cotton - great for sensitive skin and to prevent overheating \n * Combed and ring-spun for durability, softness and no-pill washing \n * Supple 1x1 rib knit fabric is naturally stretchier and more durable than plain knit fabric \n * Made in India \n * Style # LY24502-RUS",
  tags: [],
  msrpDollars: 12.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:28.343Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
